var _style, _path, _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.28 42.72",
    style: {
      enableBackground: "new 0 0 42.28 42.72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#929292;}\n\t.st1{fill:#646363;}\n\t.st2{fill:#24BBE7;}\n\t.st3{fill:#59BBA8;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.28,26.8L42.28,26.8l0-15.24h0V26.8z M22.06,15.14l7.53,4.35l11.12-8.82L22.06,0V15.14z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "20.22,0 1.57,14.7 12.69,21.11 20.22,15.14 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "0,31.16 20.22,42.72 20.22,27.58 0,15.92 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "22.06,27.58 22.06,42.72 42.28,26.78 42.28,11.54 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxLogo);
export default __webpack_public_path__ + "static/media/box-logo.2a30fd1424325a9333b7c2626a1dc2b1.svg";
export { ForwardRef as ReactComponent };